import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// import { Slide } from "react-slideshow-image";
import IndicatorTimeline from "../IndicatorTimeline";
import { Fade } from "react-slideshow-image";
import "./index.css";
import "../index.css";

const SeventhType = (props) => {
  const { data, index, activePoint, setActivePoint } = props;
  const [selectedItem, setSelectedItem] = useState(0);
  const slideRef = React.createRef();
  useEffect(() => {
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const zoomInProperties = {
    easing: "cubic",
    autoplay: data.media.length > 1,
    indicators: false,
    arrows: false,
    scale: 1.4,
  };

  return Boolean(data) && <div className='seventh_type__container'>
    <div className='seventh_type__content'>
      <div className='seventh_type__block header'>
        <IndicatorTimeline
          setActivePoint={setActivePoint}
          activePoint={activePoint}
          index={index}
          rotateClass={true}
        />
        <div className="date_container_seventh_type title">
          <h1>{data.year}</h1>
          <h3>{data.subtitle}</h3>
        </div>
      </div>
      <div className='seventh_type__block content'>
        <div className="date_container_seventh_type">
          <div dangerouslySetInnerHTML={{ __html: data.body }} />
        </div>
        <div className="image_container_seventh_type ">
          <Fade
            ref={slideRef}
            {...zoomInProperties}
            onChange={(oldIndex, newIndex) => {
              setSelectedItem(newIndex);
            }}
          >
            {data.media.map((item, index) => {
              return <img key={index} src={item.src} className="image" alt='Imagen' />
            })}
          </Fade>
        </div>
        {
          Boolean(data.media.length > 1) &&
          <div className="container_circle_buttons">
            {data.media.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`circle_button${selectedItem === index ? "_active" : ""
                    }`}
                  onClick={() => {
                    setSelectedItem(index);
                    slideRef.current.goTo(index);
                  }}
                />
              );
            })}
          </div>
        }
      </div>
    </div>
  </div>
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(SeventhType);
